import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import { translate as t } from '../../../lib/I18n';

import Order from '../../../records/Order';

import FeatureFlag from '../../general/FeatureFlag';

function DeliveryInformationPrintAtHome ({ order, isLoggedIn }) {
    const isPaid = _.result(order, 'isPaid');
    const tickets = _.result(order, 'getTickets.size', 0);
    const downloadableTickets = _.result(order, 'hasDownloadableTickets');
    return (
        <div>
            { isPaid && !downloadableTickets && (
                <div>
                    <p className="text-primary"><strong>{ t('confirmation.delivery.printAtHome.emailDetails', { tickets }) }</strong></p>
                    { isLoggedIn &&
                        <FeatureFlag name="enableTicketDownload"><p>{ t('confirmation.delivery.printAtHome.downloadShortly', { tickets }) }</p></FeatureFlag>
                    }
                </div>
            ) }
            { isPaid && downloadableTickets && (
                <div>
                    <p className="text-primary"><strong>{ t('confirmation.delivery.printAtHome.emailed', { tickets, email: order.email }) }</strong></p>
                    <FeatureFlag name="enableTicketDownload">
                        <p>{ t('confirmation.delivery.printAtHome.download', { tickets }) }</p>
                    </FeatureFlag>
                </div>
            ) }

            <p>{ t('confirmation.delivery.printAtHome.printInstructions') }</p>
        </div>
    );
}

DeliveryInformationPrintAtHome.propTypes = {
    order: PropTypes.instanceOf(Order).isRequired,
    isLoggedIn: PropTypes.bool
};

export default DeliveryInformationPrintAtHome;
